module.exports = __webpack_public_path__ + "static/media/logo-footer.dbee92c9.png";